<template>
  <van-tabbar id="footer" v-model="activeValue" @change="navChange">
    <van-tabbar-item icon="shop">我的积分</van-tabbar-item>
    <van-tabbar-item icon="bill">积分商城</van-tabbar-item>
  </van-tabbar>
</template>
<script>
import { getLocalStorage } from '@utils'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
export default {
  props: ['active'],
  data() {
    return {
      activeValue: this.active,
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    navChange(e) {
      if (e === 1) {
        this.buriedPoint()
      }
      this.$emit('update:active', e)
    }
  }
}
</script>
<style lang="scss" scoped>
#footer {
  width: 100%;
  box-shadow: 0 0 6px #eee;
  position: fixed;
  bottom: -1px;
  z-index: 100;
  background: #fff;
}
</style>
